import React, { Component } from "react";
import moment from "moment";
import swal from "sweetalert2";
import api from "../../helpers/api"
import { compressImage } from "../../helpers/imagesCompress";

export default class FormMover extends Component {
  constructor(props) {
    super(props);

    this.state = {
      principal: "",
      sec_1: "",
      sec_2: "",
      num: "",
      texto: "",
      ubi: "",
      ori: "",
      x_coord: "",
      y_coord: "",
      images: "",
      cuadrante: "",
      status: "pendiente",
      desde: moment().format("YYYY-MM-DD H:mm:ss"),
      user_id: sessionStorage.getItem("user") || 1,
      instalacion: moment().format("YYYY-MM-DD H:mm:ss"),

      // autocomplete data
      ac_calles: {},
      ac_orientaciones: {},
      ac_ubicaciones: {},
      ac_tipos: {},
      ac_cod_nuevo: {},
      ac_cod_man: {},
      ac_clases: {},
      ac_textos: {},
      ac_medidas: {},
    };

    this.form = React.createRef();
  }

  componentDidMount() {
    this.autocompletes();
    this.getCoords();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.autocomplete !== this.props.autocomplete) {
      this.autocompletes();
      window.M.updateTextFields();
    }

    if (prevProps.senal !== this.props.senal) {
      this.setState({
        x_coord: this.props.senal.x_coord,
        y_coord: this.props.senal.y_coord
      })
      this.setMap(this.props.senal.y_coord, this.props.senal.x_coord);
      window.M.updateTextFields();
    }
  }

  autocompletes = async () => {

    window.$("input#mov_nom_senal").autocomplete({
      data: this.props.autocomplete.ac_tipos,
    });

    window.$("input#mov_cod_nuevo").autocomplete({
      data: this.props.autocomplete.ac_cod_nuevo,
    });

    window.$("input#mov_cod_man").autocomplete({
      data: this.props.autocomplete.ac_cod_man,
    });

    window.$("input#mov_texto").autocomplete({
      data: this.props.autocomplete.ac_textos,
    });

    window.$("input#mov_principal").autocomplete({
      data: this.props.autocomplete.ac_calles,
    });

    window.$("input#mov_sec_1").autocomplete({
      data: this.props.autocomplete.ac_calles,
    });

    window.$("input#mov_sec_2").autocomplete({
      data: this.props.autocomplete.ac_calles,
    });

    window.$("input#mov_ubi").autocomplete({
      data: this.props.autocomplete.ac_ubicaciones,
    });

    window.$("input#mov_ori").autocomplete({
      data: this.props.autocomplete.ac_orientaciones,
    });

    window.$("input#mov_medidas").autocomplete({
      data: this.props.autocomplete.ac_medidas,
    });

    window.$("input#mov_classenal").autocomplete({
      data: this.props.autocomplete.ac_clases,
    });
  };

  async setMap(lat, lng) {
    const { newMap } = this.state;
    if (newMap !== undefined) newMap.remove();

    var mapa = window.L.map("mov-map", {
      center: [lat, lng],
      zoom: 17,
    });

    window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      foo: "bar",
      attribution:
        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors,',
      zIndex: 1,
      transparent: true,
    }).addTo(mapa);

    window.L.tileLayer
      .wms("/geoserver/tu/wms?", {
        layers: "tu:sectores",
        version: "1.1",
        zIndex: 2,
        transparent: true,
        format: "image/png",
      })
      .addTo(mapa);

    this.setState({ newMap: mapa });
    let marker = window.L.marker([lat, lng], {
      draggable: true,
      autoPan: true,
    }).addTo(mapa);

    this.setState({ marker });
    const t = this;

    marker.on("moveend", async function (e) {
      console.log(e.target._latlng.lat, e.target._latlng.lng);

      t.setState({
        x_coord: e.target._latlng.lng,
        y_coord: e.target._latlng.lat,
      });
    });
  }

  invalidateSize = async () => {
    this.state.newMap.invalidateSize();
  };

  async getCoords() {
    let t = this;

    await window.navigator.geolocation.getCurrentPosition(
      t.coordsSuccess,
      null,
      { enableHighAccuracy: true }
    );

    return { lat: this.state.lat, lng: this.state.lng };
  }

  coordsSuccess = async (position) => {
    let lat = position.coords.latitude;
    let lng = position.coords.longitude;

    this.setState({
      lat: lat,
      lng: lng,
    });

    this.setMap(lat, lng);
  };

  handleSubmitForm = async (event) => {
    event.preventDefault();

    const data = new FormData();

    data.append("cod_nuevo", document.getElementById("mov_cod_nuevo").value);
    data.append("cod_man", document.getElementById("mov_cod_man").value);
    data.append("idsenal", document.getElementById("mov_idsenal").value);
    data.append("nom_senal", document.getElementById("mov_nom_senal").value);
    data.append("classenal", document.getElementById("mov_classenal").value);
    data.append("principal", document.getElementById("mov_principal").value);
    data.append("foto", this.props.senal.foto);
    data.append("sec_1", document.getElementById("mov_sec_1").value);
    data.append("sec_2", document.getElementById("mov_sec_2").value);
    data.append("num", document.getElementById("mov_num").value);
    data.append("medidas", document.getElementById("mov_medidas").value);
    data.append("texto", document.getElementById("mov_texto").value);
    data.append("ubi", document.getElementById("mov_ubi").value);
    data.append("ori", document.getElementById("mov_ori").value);
    data.append("x_coord", this.state.x_coord);
    data.append("y_coord", this.state.y_coord);
    data.append("cuadrante", document.getElementById("mov_cuadrante").value);
    data.append("status", this.state.status);
    data.append("desde", moment().format("YYYY-MM-DD H:mm:ss"));
    data.append("user_id", this.state.user_id);
    data.append("type", "EDICION");
    data.append(
      "descripcion",
      document.getElementById("mov_descripcion").value
    );

    // data.append("instalacion", moment().format("YYYY-MM-DD H:mm:ss"));

    let senal = JSON.stringify(this.props.senal);
    data.append("senal", senal);

    if(this.state.images) {
      for (let i = 0; i < this.state.images.length; i++) {
        const imageCompressed = await compressImage(this.state.images[i])
        data.append("images", imageCompressed);
      }
    }

    api.post("/movimiento", data)
      .then((res) => {
        swal.fire({
          title: "Señal modificada",
          icon: "success",
        });

        this.form.current.reset();

        window.$("#modalNewMovimiento").modal("close");
      })
      .catch((err) => {
        console.error(err);
        swal.fire({
          title: "Error inesperado",
          icon: "error",
        });
      });

    // this.form.current.submit();
  };

  render() {
    const { senal } = this.props;
    // const texto = senal ? senal.texto : "";
    return (
      <div className="row">
        <div className="col s12">
          <div className="card">
            <form
              className="col s12 "
              style={{ marginTop: "20px" }}
              onSubmit={(event) => this.handleSubmitForm(event)}
              ref={this.form}
            >
              <div className="card-content">
                <h3 className="card-title">Editar Señal</h3>

                <div className="row">
                  <div className="col s12 mt-2">
                    <div
                      id="mov-map"
                      style={{ height: 300, width: "100%", flex: 1 }}
                    ></div>
                  </div>
                </div>

                <div className="row">
                  <div className="input-field col s12">
                    <input
                      id="mov_nom_senal"
                      type="text"
                      autoComplete="off"
                      onChange={(e) =>
                        this.setState({ nom_senal: e.target.value })
                      }
                      required
                      defaultValue={senal ? senal.nom_senal : null}
                    />
                    <label htmlFor="nom_senal">Tipo</label>
                  </div>
                </div>

                <div className="row">
                  <div className="input-field col s12">
                    <input
                      id="mov_texto"
                      type="text"
                      autoComplete="off"
                      onChange={(e) => this.setState({ texto: e.target.value })}
                      defaultValue={senal ? senal.texto : null}
                    />
                    <label className="active" htmlFor="mov_texto">
                      Texto
                    </label>
                  </div>
                </div>

                <div className="row">
                  <div className="input-field col s12 m6">
                    <input
                      id="mov_idsenal"
                      type="text"
                      autoComplete="off"
                      onChange={(e) =>
                        this.setState({ idsenal: e.target.value })
                      }
                      required
                      defaultValue={senal ? senal.idsenal : null}
                    />
                    <label htmlFor="mov_idsenal">ID</label>
                  </div>

                  <div className="input-field col s12 m6">
                    <input
                      id="mov_cuadrante"
                      type="number"
                      autoComplete="off"
                      onChange={(e) =>
                        this.setState({ cuadrante: e.target.value })
                      }
                      defaultValue={senal ? senal.cuadrante : null}
                      required
                    />
                    <label htmlFor="mov_cuadrante">Sector</label>
                  </div>
                </div>

                <div className="row">
                  <div className="input-field col s12 m6">
                    <input
                      id="mov_cod_nuevo"
                      type="text"
                      autoComplete="off"
                      onChange={(e) =>
                        this.setState({ cod_nuevo: e.target.value })
                      }
                      required
                      defaultValue={senal ? senal.cod_nuevo : null}
                    />
                    <label htmlFor="cod_nuevo">Cod. Nuevo</label>
                  </div>

                  <div className="input-field col s12 m6" style={{display: 'none'}}>
                    <input
                      id="mov_cod_man"
                      type="text"
                      autoComplete="off"
                      onChange={(e) =>
                        this.setState({ cod_man: e.target.value })
                      }
                      required
                      defaultValue={senal ? senal.cod_man : null}
                      disabled={true}
                    />
                    <label htmlFor="cod_man">Cod. Man</label>
                  </div>
                </div>

                <div className="row">
                  <div className="input-field col s12 m8">
                    <input
                      id="mov_principal"
                      type="text"
                      autoComplete="off"
                      onChange={(e) =>
                        this.setState({ principal: e.target.value })
                      }
                      required
                      defaultValue={senal ? senal.principal : null}
                    />
                    <label htmlFor="mov_principal">Calle Principal</label>
                  </div>

                  <div className="input-field col s12 m4">
                    <input
                      id="mov_num"
                      type="text"
                      autoComplete="off"
                      onChange={(e) => this.setState({ num: e.target.value })}
                      required
                      defaultValue={senal ? senal.num : null}
                    />
                    <label htmlFor="mov_num">Número Calle</label>
                  </div>
                </div>

                <div className="row">
                  <div className="input-field col s12">
                    <input
                      id="mov_sec_1"
                      type="text"
                      autoComplete="off"
                      onChange={(e) => this.setState({ sec_1: e.target.value })}
                      defaultValue={senal ? senal.sec_1 : null}
                    />
                    <label htmlFor="mov_sec_1">Calle Secundaria 1</label>
                  </div>
                </div>

                <div className="row">
                  <div className="input-field col s12">
                    <input
                      id="mov_sec_2"
                      type="text"
                      onChange={(e) => this.setState({ sec_2: e.target.value })}
                      defaultValue={senal ? senal.sec_2 : null}
                    />
                    <label htmlFor="mov_sec_2">Calle Secundaria 2</label>
                  </div>
                </div>

                <div className="row">
                  <div className="input-field col s12 m6">
                    <input
                      id="mov_ubi"
                      type="text"
                      autoComplete="off"
                      onChange={(e) => this.setState({ ubi: e.target.value })}
                      required
                      defaultValue={senal ? senal.ubi : null}
                    />
                    <label htmlFor="mov_ubi">Ubicacion</label>
                  </div>

                  <div className="input-field col s12 m6">
                    <input
                      id="mov_ori"
                      type="text"
                      autoComplete="off"
                      onChange={(e) => this.setState({ ori: e.target.value })}
                      required
                      defaultValue={senal ? senal.ori : null}
                    />
                    <label htmlFor="mov_ori">Orientacion</label>
                  </div>
                </div>
                
                <div className="row">
                  <div className="input-field col s12 m6">
                    <input
                      type="text"
                      id="mov_medidas"
                      autoComplete="off"
                      onChange={(e) =>
                        this.setState({ medidas: e.target.value })
                      }
                      defaultValue={senal ? senal.medidas : null}
                    />
                    <label htmlFor="medidas">Medidas</label>
                  </div>

                  <div className="input-field col s12 m6">
                    <input
                      type="text"
                      id="mov_classenal"
                      autoComplete="off"
                      onChange={(e) =>
                        this.setState({ classenal: e.target.value })
                      }
                      defaultValue={senal ? senal.classenal : null}
                    />
                    <label htmlFor="classenal">Clase</label>
                  </div>
                </div>

                <div className="row">
                  <div className="input-field col s12">
                    <textarea
                      id="mov_descripcion"
                      autoComplete="off"
                      onChange={(e) =>
                        this.setState({ descripcion: e.target.value })
                      }
                      required
                      rows="5"
                      className="materialize-textarea"
                      defaultValue={"EDICION DE SEÑAL"}
                    />

                    <label htmlFor="mov_descripcion">
                      Descripcion del movimiento
                    </label>
                  </div>
                </div>

                <div className="row">
                  <div className="file-field input-field mb-4 col s12">
                    <div className="btn btn-sm">
                      <span>Fotos</span>
                      <input
                        id="mov_images"
                        name="mov_images"
                        type="file"
                        multiple
                        onChange={(e) =>
                          this.setState({ images: e.target.files })
                        }
                      />
                    </div>

                    <div className="file-path-wrapper">
                      <input
                        className="file-path validate"
                        type="text"
                        placeholder="Puedes ingresar mas de una foto..."
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-action mb-4">
                <button className="btn btn-small float-right" type="submit">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
